export enum WorkshopSectionTemplate {
  topCopy = 'topCopy',
  topImage = 'topImage',
  bottomCopy = 'bottomCopy',
  bottomImage = 'bottomImage',
}
